import styled from 'styled-components';
import breakPoints from '../../../theme-redesign/Media';

export const CenteredSliderStyled = styled.div.attrs({
  className: 'CenteredSliderStyled',
})`
  width: 100%;
  max-width: 70rem;
  margin: 1rem auto;

  > .Title {
    text-align: center;
    letter-spacing: normal;
    margin-bottom: 0.5rem;
  }

  > .Text {
    text-align: center;
    margin-bottom: 1.5rem;
    padding: 0 1rem;
  }

  .Button {
    margin: 1rem auto;
  }

  .slick-slide {
    height: auto;
  }

  .slick-arrow {
    display: none !important;
  }

  .slick-dots {
    margin-top: 1rem;

    li {
      button {
        border: 1px solid ${({ theme }) => theme.farmProject.green};
      }
    }

    .slick-active {
      button {
        background-color: ${({ theme }) => theme.farmProject.green};
        border: 1px solid ${({ theme }) => theme.farmProject.green};
      }
    }
  }

  @media ${breakPoints.large_break} {
    > .Title {
      font-size: 5rem;
      margin-bottom: 1rem;
    }
  }
`;
